import React, {Component} from "react";
import styled, {keyframes} from "styled-components";
import {ArrowRightCircle} from "react-feather";
import {ChevronsDown} from "react-feather";
import AnchorLink from "react-anchor-link-smooth-scroll";

import {
  LargeTitle,
  ContainWPadding,
  HugeTitle,
  SmallTitle,
  primary,
  Margin,
  SmallMargin,
  SplashTitle,
  MediumTitle,
  LongArrowWhite
} from "../Tools/Variables";
import BgImg from "../Images/betongsang.jpg";
import Header from "../Global/Header";
import MailChimpModal from "../Global/MailChimpModal";

const Wrapper = styled.div `
  position: relative;
  width: 100vw;
  height: 100vh;
  min-height: 500px;
  max-height: 1700px;
  background-size: cover;
  background-position: left;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Overlay = styled.div `
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  background: #000000;
  opacity: 0.6;
  z-index: 1;
`;

const TextContainer = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  line-height: 2;
  margin-left: 20px;
  margin-top: 20vh;

  color: white;
  z-index: 2;
`;

const InterestBtn = styled.button `
  font-family: inherit;
  color: inherit;
  text-transform: uppercase;
  font-size: 15px;
  font-weight: 300;
  min-height: 50px;
  line-height: 50px;
  background: none;
  position: absolute;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  vertical-align: middle;
  cursor: pointer;

  border: none;

  bottom: 0px;
  transform: translateY(150%);
`;

const Marked = styled.span `
  position: relative;
`;

export const AnimateMarked = keyframes `

  from {

    transform: scaleX(0);
  }
  to {
    
    transform: scaleX(1);
  }
  
}
`;

const MarkedOverlay = styled.span `
  height: 1px;
  width: 100%;
  transform: scaleX(0);
  z-index: -1;
  opacity: 1;
  position: absolute;
  bottom: -5px;
  background: ${primary};
  background: white;
  transform-origin: left;
  animation: ${AnimateMarked} 0.8s ease-in-out forwards;
  animation-delay: 1.5s;
`;

export const AnimateContinue = keyframes `

  from {

    opacity: 0;
    transform: translateY(0);
  }
  50%{
    opacity: 1;
  }
  to {
    opacity: 0.5;
    transform: translateY(10px);
    
  }
  
}
`;

const ContinueBtn = styled.button `
  opacity: 0;
  background: none;
  border: none;

  cursor: pointer;
  position: absolute;
  color: white;
  margin: 0 auto;

  height: 50px;
  width: 50px;
  width: 100%;
  left: 0;
  bottom: 5vh;
  z-index: 1;

  animation: ${AnimateContinue} 5s ease-in-out infinite alternate;

  animation-delay: 3.5s;
`;

const SplashLine = styled.div `
  display: inline-block;
  height: 4px;
  width: 80px;
  background: white;
  margin-bottom: 20px;
  margin-left: -20px;
`;

class Thanks extends Component {
  state = {
    showContactModal: false
  };

  setShowContactModal = () => {
    this.setState({showContactModal: true});
  };
  setHideContactModal = () => {
    this.setState({showContactModal: false});
  };

  render() {
    return (
      <Wrapper style={{
        backgroundImage: "url(" + BgImg + ")"
      }}>
        <Header setShowContactModal={this.setShowContactModal}/>
        <MailChimpModal
          showContactModal={this.state.showContactModal}
          setHideContactModal={this.setHideContactModal}
          setShowContactModal={this.setShowContactModal}/>
        <ContainWPadding>
          <TextContainer>
            <SplashTitle>Välkommen!</SplashTitle>
            <MediumTitle
              style={{
              fontWeight: 200,
              maxWidth: 500
            }}>
              Ett välkomstmail väntar i din inkorg! Hittar du ingenting? Dubbelkolla i
              skräpposten. Fortfarande tomt? Skicka ett mail till {" "}
              <a href='mailto:info@modilect.com'>
                info@modilect.com
              </a>{" "}
              eller testa igen , tack!
            </MediumTitle>

          </TextContainer>
          <Overlay/>
        </ContainWPadding>
      </Wrapper>
    );
  }
}

export default Thanks;



// WEBPACK FOOTER //
// ./src/Home/Thanks.js